<template>
  <div>
    <asc-fault-monitor-detail-item-header
      :item="item"
    ></asc-fault-monitor-detail-item-header>
    <div class="asc-fault-monitor-detail--container">
      <asc-fault-monitor-detail-item-detail
        :item="item"
      ></asc-fault-monitor-detail-item-detail>
    </div>
  </div>
</template>

<script>
import AscFaultMonitorDetailItemHeader from './AscFaultMonitorDetailItemHeader'
import AscFaultMonitorDetailItemDetail from './AscFaultMonitorDetailItemDetail'

export default {
  name: 'AscFaultMonitorDetailItem',

  components: {
    AscFaultMonitorDetailItemHeader,
    AscFaultMonitorDetailItemDetail,
  },

  props: {
    item: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.asc-fault-monitor-detail--container {
  margin: 12px 0;
}
</style>
